import { SlideThumbnailBody } from "@/components/slides/list/SlideThumbnail";
import { CANVAS_SIZE } from "@/lib/constants/slides";
import type { SlideFields } from "@/types/Slide";

/** A section's reference slide, rendered small — the one preview that says what it builds. */
export function ReferenceSlideThumbnail({
  slide,
  width,
}: {
  slide: SlideFields;
  width: number;
}) {
  return (
    <div
      aria-hidden="true"
      style={{ width, height: Math.round(width / CANVAS_SIZE.freeform.aspectRatio) }}
      className="shrink-0 overflow-hidden rounded-md border border-gray-200 bg-surface dark:border-gray-700"
    >
      <SlideThumbnailBody slide={slide} width={width} />
    </div>
  );
}
